import type { IPascoRepository } from "@src/domain/pascos/repository/pasco_repository";
import type { ExtractedMetadataDTO } from "../dto";

/**
 * Use Case: Extract PASCO Metadata
 * Triggers AI-based metadata extraction for a raw PASCO document.
 * Used during admin approval workflow when metadata is missing.
 */
export class ExtractPascoMetadataUseCase {
    constructor(private readonly pascoRepository: IPascoRepository) {}

    /**
     * Execute the use case
     * @param pascoId - The unique identifier of the PASCO to extract metadata from
     * @returns Promise<ExtractedMetadataDTO> - The extracted metadata
     * @throws Error if pascoId is invalid or extraction fails
     */
    async execute(pascoId: string): Promise<ExtractedMetadataDTO> {
        if (!pascoId || pascoId.trim() === '') {
            throw new Error('PASCO ID is required');
        }

        const result = await this.pascoRepository.extractMetadata(pascoId);
        return result;
    }
}
